const tr = {
  toHome: '正在為您跳轉首頁...',
  loginSuccess: '登入成功',
  loginFailed: '登入失敗',
  acntNotExist: '帳號不存在,請檢查',
  acntOrPwdError: '帳號或密碼錯誤',
  checkFailed: '校驗失敗',
  selOrg: '請選擇您要進入的組織',
  orgTip1: '此帳號參與組織不存在，且沒有參與其他組織，請聯絡管理員。',
  login: '登入',
  carousel: '輪播圖',
  acnt: '帳號',
  enterAcnt: '請輸入',
  pwd: '密碼',
  enterPwd: '請輸入您的密碼',
  remberPwd: '記住密碼',
  noOrgTip1: '該帳戶沒有參與組織，請聯系管理員',
  pageNotFoundTitle: '找不到頁面',
  pageNotFoundTip: '抱歉，您訪問的頁面不存在。',
  goToBackHome: '返回首頁',
  phoneDisabledTip: '該手機號已被禁用，請聯系管理員。',
  welcome: '歡迎來到{{ name }}'
};

export default tr;